import { Gutter } from 'antd/lib/grid/row';
import { FieldType } from 'enums/FieldTypeEnums';
import { FocusEventHandler } from 'react';
import { FieldsRowProps } from 'shared/components/FieldsRow';

export const getLocationDataLayout = (
  handleOnBlur: FocusEventHandler
): FieldsRowProps => {
  return {
    data: [
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: 'street',
          placeholderstring: 'Street, Locality',
          label: 'Street',
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: 'city',
          placeholderstring: 'City',
          label: 'City',
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: 'province',
          placeholderstring: 'Province',
          label: 'Province',
          onBlur: handleOnBlur,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: 'country',
          placeholderstring: 'Country',
          label: 'Country',
          onBlur: handleOnBlur,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: 'postalCode',
          placeholderstring: 'Postal Code',
          label: 'Postal Code',
        },
        span: 12,
      },
    ],
    rowGutter: [20, 25] as Gutter,
  };
};
